import { useState } from "react";
import Navbar from "./Components/Navbar";
import Sidebar from "./Components/Sidebar";
import './App.css'
import MainCotent from "./Components/MainCotent";
import { useAuthState } from "./Helper/Context/context";
import { useDispatch } from "react-redux";

function MainDashboard() {
  const [isopen, setIsOpen] = useState(false);

  // console.log(Data.logoPhoto)

  const userDetails = useAuthState();
  const { UserID, token, } = userDetails
  const dispatch = useDispatch()

  // const currentYear = new Date().getFullYear();

  const [YearValue, setYearValue] = useState(null)
  const [YearLabel, setYearLabel] = useState(null)
  const [MonthValue, setMonthValue] = useState(null)
  const [MonthLabel, setMonthLabel] = useState(null)

  const toggle = () => {
    setIsOpen(!isopen);

  };

  
  return (
    <>
      {/* <div className="wrapper"> */}
      <div className="backrounf">
        <div className="container-scroller ">
          <Navbar
            setYearValue={setYearValue}
            setYearLabel={setYearLabel}
            setMonthValue={setMonthValue}
            setMonthLabel={setMonthLabel}
            toggle={toggle}
            isopen={isopen} />
          <div className="container-fluid page-body-wrapper">
            <Sidebar isopen={isopen} toggle={toggle} active="Dashboard" />
            <div className="main-panel" style={{ width: isopen ? "calc(100%  - 120px )" : "", marginLeft: isopen ? "130px" : "" }}>
              <div className="content-wrapper pl-2">
                <MainCotent />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
}

export default MainDashboard;
